import {
  Datagrid,
  TextField,
  // SearchInput,
  TextInput,
  SelectInput,
  useTranslate,
  DateInput,
  useStore,
  SelectField,
  // FunctionField,
  // BooleanInput,
  // BooleanField,
  // NumberField,
  // FunctionField,
} from 'react-admin'
import { ListBase } from '../../components/base'
import { BranchSelect } from '../../components/app-bar/type'
import { DateField, NameField } from '../../components/fields'
import { BOOKINGVIEW_FIELDS, COMMON_FIELDS } from '../../providers/localization/constant'
import dayjs from 'dayjs'
import { BookingTimeField } from '../../components/domains/bookings'

const BookingViewListFilters = (): JSX.Element[] => {
  const translate = useTranslate()
  return [
    // <SearchInput
    //   key={0}
    //   source='q'
    //   alwaysOn
    //   InputLabelProps={{ shrink: true }}
    //   InputProps={{ notched: false }}
    //   placeholder={translate(`${BOOKINGVIEW_FIELDS}.name`)}
    // />,
    <DateInput
      key={0}
      source='start_date'
      alwaysOn
      label={translate(`${BOOKINGVIEW_FIELDS}.start_date`)}
    />,
    <DateInput
      key={1}
      source='end_date'
      alwaysOn
      label={translate(`${BOOKINGVIEW_FIELDS}.end_date`)}
    />,
    <TextInput key={2} source='book_id' label={translate(`${BOOKINGVIEW_FIELDS}.book_id`)} />,
    <TextInput
      key={3}
      source='fname_lname'
      label={translate(`${BOOKINGVIEW_FIELDS}.fname_lname`)}
    />,
    <TextInput key={4} source='tel' label={translate(`${BOOKINGVIEW_FIELDS}.tel`)} />,
    <TextInput key={5} source='email' label={translate(`${BOOKINGVIEW_FIELDS}.email`)} />,
    <SelectInput
      key={6}
      label={`${BOOKINGVIEW_FIELDS}.status.label`}
      source='status'
      choices={[
        { id: 'pending', name: `${BOOKINGVIEW_FIELDS}.status.choices.pending` },
        { id: 'confirm', name: `${BOOKINGVIEW_FIELDS}.status.choices.confirm` },
        { id: 'cancel', name: `${BOOKINGVIEW_FIELDS}.status.choices.cancel` },
        { id: 'reserve', name: `${BOOKINGVIEW_FIELDS}.status.choices.reserve` },
        { id: 'complete', name: `${BOOKINGVIEW_FIELDS}.status.choices.complete` },
        { id: 'temporary_request', name: `${BOOKINGVIEW_FIELDS}.status.choices.temporary_request` },
      ]}
    />,
  ]
}

const BookingViewList = (): JSX.Element => {
  const [globalBranch] = useStore<BranchSelect>('branch.selected')
  const currentDate = dayjs().format('YYYY-MM-DD')
  // const translate = useTranslate()
  return (
    <ListBase
      listAction={{
        hasExport: false,
        hasCreate: false,
      }}
      filter={{ branch_codes: globalBranch?.id }}
      filterDefaultValues={{
        start_date: currentDate,
        end_date: currentDate,
      }}
      filters={BookingViewListFilters()}
      sort={{ field: 'create_at', order: 'DESC' }}
    >
      <Datagrid rowClick='show' bulkActionButtons={false}>
        <TextField source='book_id' label={`${BOOKINGVIEW_FIELDS}.book_id`} sortable={false} />
        <NameField
          firstNameSource='first_name'
          lastNameSource='last_name'
          source='first_name'
          label={`${BOOKINGVIEW_FIELDS}.name`}
          sortable={false}
          emptyText='-'
        />
        <TextField
          source='tel'
          label={`${BOOKINGVIEW_FIELDS}.tel`}
          sortable={false}
          emptyText='-'
        />
        <TextField
          source='email'
          label={`${BOOKINGVIEW_FIELDS}.email`}
          sortable={false}
          emptyText='-'
        />
        <DateField
          source='booking_date'
          label={`${BOOKINGVIEW_FIELDS}.booking_date`}
          // showTime
          // textAlign='center'
        />
        <BookingTimeField
          style={{ fontSize: 14 }}
          source='booking_start_time'
          label={`${BOOKINGVIEW_FIELDS}.start_time`}
          showTime
          textAlign='center'
        />
        <BookingTimeField
          style={{ fontSize: 14 }}
          source='booking_end_time'
          label={`${BOOKINGVIEW_FIELDS}.end_time`}
          showTime
          textAlign='center'
        />
        <DateField
          source='create_at'
          label={`${COMMON_FIELDS}.date.created_at`}
          showTime
          // textAlign='center'
        />
        <SelectField
          source='status'
          label={`${BOOKINGVIEW_FIELDS}.status.label`}
          sortable={false}
          choices={[
            { id: 'pending', name: `${BOOKINGVIEW_FIELDS}.status.choices.pending` },
            { id: 'confirm', name: `${BOOKINGVIEW_FIELDS}.status.choices.confirm` },
            { id: 'cancel', name: `${BOOKINGVIEW_FIELDS}.status.choices.cancel` },
            { id: 'reserve', name: `${BOOKINGVIEW_FIELDS}.status.choices.reserve` },
            { id: 'complete', name: `${BOOKINGVIEW_FIELDS}.status.choices.complete` },
            {
              id: 'temporary_request',
              name: `${BOOKINGVIEW_FIELDS}.status.choices.temporary_request`,
            },
          ]}
        />
      </Datagrid>
    </ListBase>
  )
}

export default BookingViewList
